import React, { useState } from 'react';
import mobile from '../../assets/mobile.png';
import { Button, CircularProgress } from '@mui/material';
import Alert from '@mui/material/Alert';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import MailIcon from '@mui/icons-material/Mail';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import RoomIcon from '@mui/icons-material/Room';
import GitHubIcon from '@mui/icons-material/GitHub';
import SendIcon from '@mui/icons-material/Send';
import email from '../../assets/email.png';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import './Footer.scss';
import AppWrap from './../../wrapper/AppWrap';
import MotionWrap from './../../wrapper/MotionWrapper';
import { client } from './../../Client';

const Footer = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '',subject : '' });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { name, email, message ,subject} = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    setLoading(true);

    const contact = {
      _type: 'contact',
      name: formData.name,
      email: formData.email,
      subject: formData.subject,
      message: formData.message,
    };

    client.create(contact)
      .then(() => {
        setLoading(false);
        setIsFormSubmitted(true);
        setFormData({ name: '', email: '', message: '',subject : '' });
      })
      .catch((err) => console.log(err));

       
  };

  return (
    <>
     <div className='contactPage container pb-5'>
            <div className='title-section'>
                <h1 className="text-secondary">contact <span>me</span></h1>
                <span className='title-bg'>connect</span>
            </div>
            <div className='row m-auto mt-5'>
                <div className='contact col-lg-6 col-md-12'>
                    <h2 data-aos='slide-down'>Leave Me A Message...</h2>
                    <Box data-aos="zoom-in">
                    <p className='text-secondary'>
                        Have any works you want to done by me? <a href="#contact"><span style={{ color: '#0779E4' }}> Contact Me</span></a>
                    </p>
                    <p className='text-secondary'>
                        If you have any question or suggestion for me and need more information about me and my work, then <br />--please contact me.
                    </p>
                </Box>
                    <div style={{ width: 'fit-content' }}>
                        <a href="mailto:pinky.rani.banik@gmail.com" target='_blank' rel='noreferrer'>
                            <div data-aos='flip-left' className='row py-2'>
                                <div className='col-3'>
                                    <i><MailIcon /></i>
                                </div>
                                <div className='col-9'>
                                    <h5>Email Address :</h5>
                                    <p>pinky.rani.banik@gmail.com</p>
                                </div>
                            </div>
                        </a>
                        <a href="tel:+8801521445334" target='_blank' rel='noreferrer'>
                            <div data-aos='flip-left' className='row py-2'>
                                <div className='col-3'>
                                    <i><PhoneInTalkIcon /></i>
                                </div>
                                <div className='col-9'>
                                    <h5>Phone Number :</h5>
                                    <p>+8801521445334</p>
                                </div>
                            </div>
                        </a>
                        <a href="//" target='_blank' rel='noreferrer'>
                            <div data-aos='flip-right' className='row py-2'>
                                <div className='col-3'>
                                    <i><RoomIcon /></i>
                                </div>
                                <div className='col-9'>
                                    <h5>My Location :</h5>
                                    <p>Bhatikashore, Mymensingh</p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div>
                        <ul className='socialIcon'>
                            <li data-aos='slide-up' >
                                <a href="https://www.facebook.com/Pinky.Rani.Banik/" target="_blank" rel='noreferrer'><FacebookIcon sx={{ fontSize: '1.9rem' }} /></a>
                            </li>
                            <li data-aos='slide-up' >
                                <a href="https://www.facebook.com/Pinky.Rani.Banik/" target="_blank" rel='noreferrer'><LinkedInIcon sx={{ fontSize: '1.9rem' }} /></a>
                            </li>
                            <li data-aos='slide-left' >
                                <a href="https://github.com/pinky-banik" target="_blank" rel='noreferrer'><GitHubIcon sx={{ fontSize: '1.9rem' }} /></a>
                            </li>
                            <li data-aos='slide-left' >
                                <a href="https://www.instagram.com/pinky__banik/" target="_blank" rel='noreferrer'><InstagramIcon sx={{ fontSize: '1.9rem' }} /></a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='col-lg-6 col-md-12 flex justify-center items-center'>
                  <div className="message">
                    <input data-aos="zoom-in" required placeholder='Your Name*' type="text" name="name" className="p-text"    value={name} onChange={handleChangeInput}  />
                      <input data-aos="zoom-in" className="p-text" type="email" placeholder="Email Address*" name="email" value={email} onChange={handleChangeInput} required/>
                      <input 
                      data-aos="zoom-in"
                       name='subject'
                       value={subject}
                        placeholder='Subject*' 
                        type="text"onChange={handleChangeInput}  />
                      <textarea
                      data-aos="zoom-in"
                        className="p-text"
                        placeholder="Write Your Message*"
                        value={message}
                        name="message"
                        onChange={handleChangeInput}
                        required
                      />
                    {/* <button type="button" data-aos="zoom-in" sx={{ fontWeight: 'bold' }} variant="contained" onClick={handleSubmit}>{!loading ? 'Send Message' : 'Sending...'}</button> */}
                    <Button
                    onClick={handleSubmit}
                    type="button"
                    
                      data-aos="zoom-in" 
                      sx={{ fontWeight: 'bold' }}
                      variant="contained">
                        {!loading ? <>
                      <SendIcon /> Send Message </>: <>
                      <div class="spinner-border text-light mx-1 "  role="status">
                      </div>Sending...</>}</Button>
                  </div>
      
        {
          isFormSubmitted &&
          <Alert sx={{ mt: 2 }} severity="success">Your Message Send Successfully</Alert>
      }
                </div>
            </div >
        </div >
      {/* <h2 className="head-text text-[#2430af]">Take a coffee & chat with me</h2>

      <div className="app__footer-cards">
        <div className="app__footer-card ">
          <img src={email} alt="email" />
          <a href="mailto:hello@micael.com" className="p-text">hello@micael.com</a>
        </div>
        <div className="app__footer-card">
          <img src={mobile} alt="phone" />
          <a href="tel:+1 (123) 456-7890" className="p-text">+1 (123) 456-7890</a>
        </div>
      </div>
      {!isFormSubmitted ? (
        <div className="app__footer-form app__flex">
          <div className="app__flex">
            <input className="p-text" type="text" placeholder="Your Name" name="username" value={username} onChange={handleChangeInput} />
          </div>
          <div className="app__flex">
            <input className="p-text" type="email" placeholder="Your Email" name="email" value={email} onChange={handleChangeInput} />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              value={message}
              name="message"
              onChange={handleChangeInput}
            />
          </div>
          <button type="button" className="p-text" onClick={handleSubmit}>{!loading ? 'Send Message' : 'Sending...'}</button>
        </div>
      ) : (
        <div>
          <h3 className="head-text">
            Thank you for getting in touch!
          </h3>
        </div>
      )} */}
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__primarybg',
);